import { STORAGE_KEYS, clearKeysByPrefix, storage } from './storage.js'

export const stableStringify = (value) => {
  if (Array.isArray(value)) return `[${value.map(stableStringify).join(',')}]`
  if (value && typeof value === 'object') return `{${Object.keys(value).sort().map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`).join(',')}}`
  return JSON.stringify(value)
}

export const hashText = (text) => {
  let hash = 2166136261
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }
  return (hash >>> 0).toString(36)
}

export const createAiCacheKey = ({ policies, goals, adjustments, filter, provider, model, promptVersion = 'report-v3' }) => {
  const content = stableStringify({ policies, goals, adjustments, filter, provider, model, promptVersion })
  return `hx_ai_report_v3:${provider}:${model}:${hashText(content)}`
}

const loadIndex = () => storage.json(STORAGE_KEYS.aiCacheIndex, [])

export const saveAiCache = (key, payload, limit = 8) => {
  storage.set(key, JSON.stringify(payload))
  storage.set(STORAGE_KEYS.aiReportLatest, JSON.stringify(payload))
  const next = [key, ...loadIndex().filter((item) => item !== key)]
  next.slice(limit).forEach((expiredKey) => storage.remove(expiredKey))
  storage.set(STORAGE_KEYS.aiCacheIndex, JSON.stringify(next.slice(0, limit)))
}

export const loadAiCache = (key) => {
  const payload = storage.json(key, null)
  return payload?.content ? payload : null
}

export const listAiReports = () => loadIndex().map((key) => storage.json(key, null)).filter((item) => item?.content)

export const clearAiCache = () => {
  clearKeysByPrefix(['hx_ai_report_', 'hx_ai_note_cache:'])
  storage.remove(STORAGE_KEYS.aiReportLatest)
  storage.remove(STORAGE_KEYS.aiCacheIndex)
  storage.remove(STORAGE_KEYS.noteCacheIndex)
}
